import React from "react"
import { usePaths } from "@engaging-tech/routing"

import { libraryPostTypes } from "../../../features/userGeneratedContent/lib/postTypes"

import DetailsLayout from "../../../layouts/DetailsLayout"
import AuthGuard from "../../../features/ui/containers/AuthGuard"
import Publish from "../../../features/businessLibrary/containers/Publish"

const PublishResearchForm = Publish(libraryPostTypes.research)

const Lecture = () => {
  const paths = usePaths()

  return (
    <AuthGuard>
      <DetailsLayout
        backTo={paths.resourceCentre.browse.research.selectedResearch}
      >
        <PublishResearchForm />
      </DetailsLayout>
    </AuthGuard>
  )
}

export default Lecture
